module.exports = __webpack_public_path__ + "18b78ea70c57db50b7b798b714b2893e.webp";